import React, { useRef, useState, useEffect } from 'react'
import { Image, Icon, Dropdown, Dimmer, Loader } from 'semantic-ui-react'
import styled from 'styled-components'

//import PropTypes from 'prop-types';

const StyledIcon = styled(Icon)`
  position: static;
`
const StyledImage = styled(Image)`
  position: static;
`

const opacity = { opacity: 1 }

const AvatarDimmer = ({ isLoading }) => (
  <Dimmer active={isLoading}>
    <Loader size="small" />
  </Dimmer>
)

const AvatarImage = ({ url, setOpen, isLoading, name, attributes }) => {
  return url ? (
    <StyledImage
      circular
      src={url}
      dimmer={<AvatarDimmer isLoading={isLoading} />}
      {...attributes}
      onClick={() => setOpen((open) => !open)}
    />
  ) : (
    <StyledIcon name={name} size="big" circular {...attributes} onClick={() => setOpen((open) => !open)} />
  )
}

const Avatar = ({ editable = false, onSelectedFile, name, size = 'tiny', url, isLoading = false, ...attributes }) => {
  const fileInput = useRef(null)
  const [objectUrl, setObjectUrl] = useState(null)
  const [open, setOpen] = useState(false)
  const URL = isLoading ? objectUrl : url
  const handleEdit = () => {
    fileInput.current && fileInput.current.click()
  }
  const handleDelete = () => {
    fileInput.current.value = ''
    revokeUrl()
    setObjectUrl(null)
    setOpen(false)
  }
  const revokeUrl = () => objectUrl && window.URL.revokeObjectURL(objectUrl)
  const onSelectFile = (ev) => {
    const file = ev.target.files && ev.target.files[0]
    if (!file) return
    if (!/^image\//.test(file.type)) {
      alert('Imagem inválida')
      return
    }
    revokeUrl()
    const oURL = window.URL.createObjectURL(file)
    if (onSelectedFile) onSelectedFile(file)
    setObjectUrl(oURL)
    setOpen(false)
  }
  useEffect(() => () => revokeUrl())

  return (
    <Dropdown
      trigger={
        <AvatarImage
          url={URL}
          size={size}
          name={name}
          setOpen={setOpen}
          isLoading={isLoading}
          attributes={attributes}
        />
      }
      //options={options}
      open={open}
      onBlur={() => setOpen(false)}
      icon={null}
      style={opacity}
      disabled={!editable}
    >
      <Dropdown.Menu>
        <input
          type="file"
          onChange={onSelectFile}
          accept="image/gif,image/jpeg,image/png"
          style={{ display: 'none' }}
          ref={fileInput}
        />
        <Dropdown.Item icon="upload" onClick={handleEdit} />
        <Dropdown.Item icon="trash" onClick={handleDelete} />
      </Dropdown.Menu>
    </Dropdown>
  )
}

/* Avatar.defaultProps = {
    showEditButton: false,
    onEdit: null,
    size: 'big',
 editButton: defaultEditButton, 
}; */

export default Avatar
